export default __webpack_public_path__ + "static/media/PreSeasonHeaderImage.f9c928df.jpg";